class ProductSelector extends HTMLElement {
    constructor() {
        super();
        this.blocks = [];
        this.activeIndex = 0;
        this.mediaQuery = null;
    }

    connectedCallback() {
        const rangeOptions = this.querySelectorAll('.product-selector__range-option');
        const rangePills = this.querySelectorAll('.product-selector__range-pill');

        const handleSelect = (e) => {
            const index = parseInt(e.currentTarget.dataset.blockIndex, 10);
            this.#selectBlock(index);
        };

        rangeOptions.forEach((option) => option.addEventListener('click', handleSelect));
        rangePills.forEach((pill) => pill.addEventListener('click', handleSelect));

        this.#setupViewTransitions();
    }

    #setupViewTransitions() {
        const contentInner = this.querySelector('.product-selector__content-inner');
        if (!contentInner) return;

        this.mediaQuery = window.matchMedia('(min-width: 768px)');

        const updateLayout = () => {
            const isDesktop = this.mediaQuery.matches;

            if (document.startViewTransition) {
                document.startViewTransition(() => {
                    contentInner.classList.toggle('product-selector__content-inner--desktop', isDesktop);
                });
            } else {
                contentInner.classList.toggle('product-selector__content-inner--desktop', isDesktop);
            }
        };

        this.mediaQuery.addEventListener('change', updateLayout);
        updateLayout();
    }

    #selectBlock(index) {
        if (index === this.activeIndex) return;
        this.activeIndex = index;

        const updateDOM = () => {
            const rangeOptions = this.querySelectorAll('.product-selector__range-option');
            const rangePills = this.querySelectorAll('.product-selector__range-pill');
            const contentBlocks = this.querySelectorAll('.product-selector__block');
            const mediaBlocks = this.querySelectorAll('.product-selector__media-block');

            rangeOptions.forEach((opt) => {
                const optIndex = parseInt(opt.dataset.blockIndex, 10);
                const isActive = optIndex === index;
                opt.classList.toggle('product-selector__range-option--active', isActive);
                opt.setAttribute('aria-pressed', isActive);
            });

            rangePills.forEach((pill) => {
                const pillIndex = parseInt(pill.dataset.blockIndex, 10);
                const isActive = pillIndex === index;
                pill.classList.toggle('product-selector__range-pill--active', isActive);
                pill.setAttribute('aria-pressed', isActive);
            });

            contentBlocks.forEach((block) => {
                block.classList.toggle('product-selector__block--active', parseInt(block.dataset.blockIndex, 10) === index);
            });

            mediaBlocks.forEach((block) => {
                block.classList.toggle('product-selector__media-block--active', parseInt(block.dataset.blockIndex, 10) === index);
            });
        };

        if (document.startViewTransition) {
            document.startViewTransition(updateDOM);
        } else {
            updateDOM();
        }
    }
}

customElements.define('product-selector', ProductSelector);
